import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface CartItem {
  cart_item_id: string;
  menu_item_id: string;
  item_name: string;
  quantity: number;
  unit_price: string; // API string
  line_total: string; // API string
  special_instructions: string;
  item_image?: string;
}

export interface AddCartData {
  cart_id: string;
  session_id: string;
  items: CartItem[];
  service_charge_amount: string;
  subtotal: string;
  tax_amount: string;
  total_amount: string;
  item_count: number;
}

export interface CartState {
  data: AddCartData | null;
  loading: boolean;
  error: string | null;
  isAdding: boolean;
}

// ---------------------
// Initial State
// ---------------------
const initialState: CartState = {
  data: null,
  loading: false,
  error: null,
  isAdding: false,
};

// ---------------------
// Slice
// ---------------------
export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartData: (state, action: PayloadAction<AddCartData>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },

    setCartLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) {
        state.error = null;
      }
    },
    setIsAdding: (state, action: PayloadAction<boolean>) => {
      state.isAdding = action.payload;
    },

    setCartError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },

    clearCart: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setCartData,
  setCartLoading,
  setCartError,
  clearCart,
  setIsAdding,
} = cartSlice.actions;

export default cartSlice.reducer;
